export default __webpack_public_path__ + "static/media/lista-vacia.15d19e5b.svg";